/* unplugin-vue-components disabled */import script from "./IssueTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./IssueTable.vue?vue&type=script&lang=ts&setup=true"

import "./IssueTable.vue?vue&type=style&index=0&id=1a8af1c3&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a8af1c3"]])

export default __exports__